import { SAVED_RETURNED_ENDPOINT } from '../endpoints/returned'
import updateRequest from '../request/updateRequest'

export default async ({ id, formData }) => {
  try {
    const response = await updateRequest({
      url: `${SAVED_RETURNED_ENDPOINT}/${id}`,
      formData
    })
    const { data } = response.data
    const status = response.status
      
    alert(data)
  } catch (error) {
    const { Error } = error.response.data
    const status = error.response.status
      
    alert(Error)
  }
}
